import { useTranslation } from "react-i18next";
import { PlatformSocial } from "@/partner/features/platformSocial";
import { Meta } from "@/shared/components";

export const PlatformSocialPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("platformSocial.pageTitle")} pageType="Partner" />
      <PlatformSocial />
    </>
  );
};
